import { Action, ActionCreator } from 'redux';
import React from 'react';

export enum GlobalActionTypes {
    LOGOUT = 'LOGOUT',
    OPEN_SPINNER_STATE = 'OPEN_SPINNER_STATE',
    IMPORTING_OR_EXPORTING_PROJECT_STATE = 'IMPORTING_OR_EXPORTING_PROJECT_STATE',
    SET_TASK_REFRESH = 'SET_TASK_REFRESH',
    ADD_FINISHED_BACKGROUND_TASK = 'ADD_FINISHED_BACKGROUND_TASK',
    ADD_FILE_UPLOAD_TASK = 'ADD_FILE_UPLOAD_TASK',
    UPDATE_PROGRESS_FILE_UPLOAD_TASK = 'UPDATE_PROGRESS_FILE_UPLOAD_TASK',
    REMOVE_FILE_UPLOAD_TASK = 'REMOVE_FILE_UPLOAD_TASK',
    ALL_REMOVE_FILE_UPLOAD_TASK = 'ALL_REMOVE_FILE_UPLOAD_TASK',
    ADD_DOCKED_DIALOG = 'ADD_DOCKED_DIALOG',
    REMOVE_DOCKED_DIALOG = 'REMOVE_DOCKED_DIALOG',
    ALL_REMOVE_DOCKED_DIALOGS = 'ALL_REMOVE_DOCKED_DIALOGS',
    SET_IDLE_TIME = 'SET_IDLE_TIME',
    SET_STANDARD_GRID_VIEW = "SET_STANDARD_GRID_VIEW",
    SET_USECASE_GRID_VIEW = "SET_USECASE_GRID_VIEW",
    SET_SCOPE_GRID_VIEW = "SET_SCOPE_GRID_VIEW",
    SET_WORKFLOW_REPRESENTATION_GRID_VIEW = "SET_WORKFLOW_REPRESENTATION_GRID_VIEW",
}

export interface GlobalLogout extends Action {
    type: GlobalActionTypes.LOGOUT;
    payload: {};
}

export interface GlobalAddFinishedBackgroundTask extends Action {
    type: GlobalActionTypes.ADD_FINISHED_BACKGROUND_TASK;
    payload: {
        backgroundTask: string;
    };
}

export interface GlobalAddFileUploadTask extends Action {
    type: GlobalActionTypes.ADD_FILE_UPLOAD_TASK;
    payload: {
        id: string;
        message: string;
        progress: number|null;
        //abortController: AbortController;
    };
}

export interface GlobalUpdateProgressFileUploadTask extends Action {
    type: GlobalActionTypes.UPDATE_PROGRESS_FILE_UPLOAD_TASK;
    payload: {
        id: string;
        progress: number;
    };
}

export interface GlobalRemoveFileUploadTask extends Action {
    type: GlobalActionTypes.REMOVE_FILE_UPLOAD_TASK;
    payload: {
        id: string;
    };
}

export interface GlobalRemoveAllFileUploadTask extends Action {
    type: GlobalActionTypes.ALL_REMOVE_FILE_UPLOAD_TASK;
    payload: {};
}

export interface GlobalAddDockedDialog extends Action {
    type: GlobalActionTypes.ADD_DOCKED_DIALOG;
    payload: {
        title: string;
        dialogContent: React.ReactNode;
    };
}

export interface GlobalRemoveDockedDialog extends Action {
    type: GlobalActionTypes.REMOVE_DOCKED_DIALOG;
    payload: {
        title: string;
    };
}

export interface GlobalRemoveAllDockedDialogs extends Action {
    type: GlobalActionTypes.ALL_REMOVE_DOCKED_DIALOGS;
    payload: {};
}

export interface GlobalSetTaskRefresh extends Action {
    type: GlobalActionTypes.SET_TASK_REFRESH;
    payload: {
        taskRefresh: boolean;
    };
}

export interface GlobalOpenSpinnerState extends Action {
    type: GlobalActionTypes.OPEN_SPINNER_STATE;
    payload: {
        openSpinner: boolean;
    };
}

export interface GlobalImportingOrExportingProjectState extends Action {
    type: GlobalActionTypes.IMPORTING_OR_EXPORTING_PROJECT_STATE;
    payload: {
        importingOrExporting: boolean;
    };
}

export interface GlobalSetIdleTime extends Action {
    type: GlobalActionTypes.SET_IDLE_TIME;
    payload: {
        idleTime: number;
    };
}

export interface GlobalSetStandardGridView extends Action {
    type: GlobalActionTypes.SET_STANDARD_GRID_VIEW;
    payload: {
        gridView: boolean;
    };
}

export interface GlobalSetUseCaseGridView extends Action {
    type: GlobalActionTypes.SET_USECASE_GRID_VIEW;
    payload: {
        gridView: boolean;
    };
}

export interface GlobalSetScopeGridView extends Action {
    type: GlobalActionTypes.SET_SCOPE_GRID_VIEW;
    payload: {
        gridView: boolean;
    };
}

export interface GlobalSetWorkflowRepresentationGridView extends Action {
    type: GlobalActionTypes.SET_WORKFLOW_REPRESENTATION_GRID_VIEW;
    payload: {
        gridView: boolean;
    };
}

export type GlobalActions =
    | GlobalLogout
    | GlobalAddFinishedBackgroundTask
    | GlobalOpenSpinnerState
    | GlobalImportingOrExportingProjectState
    | GlobalSetStandardGridView
    | GlobalSetUseCaseGridView
    | GlobalSetScopeGridView
    | GlobalSetWorkflowRepresentationGridView
    | GlobalSetTaskRefresh
    | GlobalAddDockedDialog
    | GlobalRemoveDockedDialog
    | GlobalRemoveAllDockedDialogs
    | GlobalAddFileUploadTask
    | GlobalUpdateProgressFileUploadTask
    | GlobalRemoveAllFileUploadTask
    | GlobalSetIdleTime
    | GlobalRemoveFileUploadTask;

export const logoutAction: ActionCreator<GlobalLogout> = () => {
    return {
        type: GlobalActionTypes.LOGOUT,
        payload: {},
    };
};

export const setStandardGridView: ActionCreator<GlobalSetStandardGridView> = (gridView: boolean) => {
    return {
        type: GlobalActionTypes.SET_STANDARD_GRID_VIEW,
        payload: {
            gridView,
        },
    };
};

export const setUseCaseGridView: ActionCreator<GlobalSetUseCaseGridView> = (gridView: boolean) => {
    return {
        type: GlobalActionTypes.SET_USECASE_GRID_VIEW,
        payload: {
            gridView,
        },
    };
};

export const setScopeGridView: ActionCreator<GlobalSetScopeGridView> = (gridView: boolean) => {
    return {
        type: GlobalActionTypes.SET_SCOPE_GRID_VIEW,
        payload: {
            gridView,
        },
    };
};

export const setWorkflowRepresentationGridView: ActionCreator<GlobalSetWorkflowRepresentationGridView> = (gridView: boolean) => {
    return {
        type: GlobalActionTypes.SET_WORKFLOW_REPRESENTATION_GRID_VIEW,
        payload: {
            gridView,
        },
    };
};

export const setTaskRefresh: ActionCreator<GlobalSetTaskRefresh> = (taskRefresh: boolean) => {
    return {
        type: GlobalActionTypes.SET_TASK_REFRESH,
        payload: {
            taskRefresh,
        },
    };
};

export const addFileUploadTask: ActionCreator<GlobalAddFileUploadTask> = (id: string, message: string, progress: number|null, abortController: AbortController) => {
    return {
        type: GlobalActionTypes.ADD_FILE_UPLOAD_TASK,
        payload: {
            id,
            message,
            progress,
            abortController,
        },
    };
};

export const updateProgressFileUploadTask: ActionCreator<GlobalUpdateProgressFileUploadTask> = (id: string, progress: number) => {
    return {
        type: GlobalActionTypes.UPDATE_PROGRESS_FILE_UPLOAD_TASK,
        payload: {
            id,
            progress,
        },
    };
};

export const removeFileUploadTask: ActionCreator<GlobalRemoveFileUploadTask> = (id: string) => {
    return {
        type: GlobalActionTypes.REMOVE_FILE_UPLOAD_TASK,
        payload: {
            id,
        },
    };
};

export const removeAllFileUploadTask: ActionCreator<GlobalRemoveAllFileUploadTask> = () => {
    return {
        type: GlobalActionTypes.ALL_REMOVE_FILE_UPLOAD_TASK,
        payload: {},
    };
};

export const addDockedDialog: ActionCreator<GlobalAddDockedDialog> = (title: string, dialogContent: React.ReactNode) => {
    return {
        type: GlobalActionTypes.ADD_DOCKED_DIALOG,
        payload: {
            title,
            dialogContent,
        },
    };
};

export const removeDockedDialog: ActionCreator<GlobalRemoveDockedDialog> = (title: string) => {
    return {
        type: GlobalActionTypes.REMOVE_DOCKED_DIALOG,
        payload: {
            title,
        },
    };
};

export const removeAllDockedDialogs: ActionCreator<GlobalRemoveAllDockedDialogs> = () => {
    return {
        type: GlobalActionTypes.ALL_REMOVE_DOCKED_DIALOGS,
        payload: {},
    };
};

export const addFinishedBackgroundTask: ActionCreator<GlobalAddFinishedBackgroundTask> = (backgroundTask: string) => {
    return {
        type: GlobalActionTypes.ADD_FINISHED_BACKGROUND_TASK,
        payload: {
            backgroundTask,
        },
    };
};

export const setOpenSpinnerState: ActionCreator<GlobalOpenSpinnerState> = (openSpinner: boolean) => {
    return {
        type: GlobalActionTypes.OPEN_SPINNER_STATE,
        payload: {
            openSpinner,
        },
    };
};

export const setImportingOrExportingState: ActionCreator<GlobalImportingOrExportingProjectState> = (importingOrExporting: boolean) => {
    return {
        type: GlobalActionTypes.IMPORTING_OR_EXPORTING_PROJECT_STATE,
        payload: {
            importingOrExporting,
        },
    };
};

export const setIdleTime: ActionCreator<GlobalSetIdleTime> = (idleTime: number) => {
    return {
        type: GlobalActionTypes.SET_IDLE_TIME,
        payload: {
            idleTime,
        },
    };
};
